<template>
	<div class="poll-container uk-position-relative">
		
		<h4 class="title" v-if="hasEntryPage"><a :href="pollData.url">{{ pollData.title }}</a></h4>
		<h4 class="title" v-else>{{ pollData.title }}</h4>
		
		<div class="uk-alert" v-if="isExpired == true">
			Poll geëindigd, er kan niet meer gestemd worden.
		</div>
		<div class="results" v-html="results"></div>
		
		<div class="poll-results" v-show="hasParticipated" v-html="pollResults"></div>
		
		<div class="poll-form" v-show="results == null && !hasParticipated">
			
			<form 
				ref="form"
				method="post" 
				action="/actions/poll/answer/submit" 
				class="poll-form" 
				:id="'poll-form-' + id"
				@submit.prevent="vote"
			>
				<!-- hidden required inputs -->
				<input type="hidden" :name="csrfName" :value="csrfToken">
				<div v-html="pollInputs"></div>
		
				<!-- answers -->
				<div class="poll-answers">
					<div v-for="answer in answerData" :key="answer.id" class="answer-container">
						
						<div class="uk-grid-small" uk-grid>
							<div class="uk-width-auto">
								<input
									type="radio"
									:name="generatePollAnswerFieldName(pollData, answer)"
									:value="generatePollAnswerFieldValue(pollData, answer)"
									class="uk-radio"
									:id="'option-radio-' + answer.id + '-' + id"
									required
								/>
							</div>
							<div class="uk-width-expand">
								<label
									:for="'option-radio-' + answer.id + '-' + id"
									style="margin-top: -3px;"
									class="uk-text-small"
								>
									{{ answer.label }}
								</label>
							</div>
						</div>
						
					</div>
				</div>

				<div class="footer uk-margin-small-top" if="showTotalComments">
					<span if="showTotalComments">
						<a :href="pollData.url">Reacties: {{ totalComments }} </a>
					</span>
				</div>
				
				<div class="uk-margin">
					<button class="uk-button uk-button-small">Stemmen</button>
				</div>
															
			</form>
		</div>

		<div class="overlay" v-show="overlay">
			 <div class="uk-position-center">
					 <div class="uk-text-center">
						 <span v-show="loading"><loading-indicator></loading-indicator></span>
						 <span v-show="error" class="material-symbols-outlined">error</span>
						 <span v-show="success" class="material-symbols-outlined">done</span>
					 </div>
					 <p class="uk-text-center" v-html="message"></p>
			 </div>
		</div>
				
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	name: 'Poll',
	components: { LoadingIndicator },
	props: {	
		id: {
			default: Date.now().toString(36) + Math.random().toString(36).substring(2)
		},		
		pollData: {
			type: Object,
			required: true
		},
		pollInputs: {
			type: String,
			required: true
		},
		answerData: {
			type: Object,
			required: true		
		},
		isExpired: {
			type: Boolean
		},
		hasParticipated: {
			type: Boolean,
			default: false
		},
		showFooter: {
			type: Boolean,
			default: true
		},
		showUsers: {
			type: Boolean,
			default: false
		},
		showTotalComments: {
			type: Boolean,
			default: false
		},	
		totalComments: {
			type: Number,
			default: 0
		},
		hasEntryPage: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			
			// Default
			overlay: false,
			error: null,
			success: false,
			loading: false,
			message: null,
			
			pollResults: null,
			
			// Poll specific
			results: null,
			resultUrl: '/async/poll_results',
			hasVoted: false,
			CFG_FORM_POLLANSWER_FIELDNAME: '__answer',
			CFG_FORM_POLLANSWERTEXT_FIELDNAME: '__text'
		}
	},
	mounted() {
		this.$logger("app/component/poll/mounted");
		
		if(this.hasParticipated) {
			this.loadPollResults();
		}
	},
	computed: {
		csrfName () {
			return window.csrfTokenName
		},
		csrfToken () {
			return window.csrfTokenValue
		},
	},
	methods: {
		generatePollAnswerFieldName(poll, answer) {
			var component = this;			
			return component.CFG_FORM_POLLANSWER_FIELDNAME + "[" + component.pollData.uid + "]";
		},
		generatePollAnswerFieldValue(poll, answer) {
			return answer.uid;
		},
		loadPollResults() {
			
			var component = this;

			// Params passed to result template
			var resultParams = {
				formId: component.id,
				pollId: component.pollData.id,
				showFooter: component.showFooter,
				showUsers: component.showUsers,
			};
			
			// Load poll results
			axios.get('/async/poll_results', {
				params: resultParams,
			})
			.then(function (response) {
				component.pollResults = response.data;
		
				setTimeout(function () {
					component.animateBars();
				}, 300);
			})
			.catch(function (error) {
				console.log(error);
			});
						
		},
		vote(e) {
			var component = this;

			// Form data
			var form = e.target;
			var formData = new FormData(e.target);

			// Custom data
			var data = {};

			// Params passed to result template
			var resultParams = {
				formId: component.id,
				pollId: component.pollData.id,
				showFooter: component.showFooter,
				showUsers: component.showUsers,
			};

			// Action and result URL
			var actionUrl = form.getAttribute("action");

			// Append CSRF
			formData.append(
				data[window.csrfTokenName],
				window.csrfTokenValue
			);

			// Toggle state
			component.overlay = true;
			component.loading = true;

			// Request
			axios({
				method: "post",
				url: actionUrl,
				responseType: "json",
				data: formData,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					Accept: "application/json",
				},
			})
			.then(function (response) {
				// Error
				if (response.data.error) {
					component.$logger("app/component/poll/response/error", "error");

					component.error = true;
					component.message = response.data.error;

					setTimeout(function() {
						component.resetMessage();
					}, 3000);
									
				// Success
				} else {
					component.$logger("app/component/poll/results/response/success");

					// Load poll results
					axios
						.get(component.resultUrl, {
							params: resultParams,
						})
						.then(function (response) {
							// Update results data							
							component.results = response.data;

							// Toggle state
							component.overlay = false;
							component.loading = false;

							setTimeout(function () {
								component.animateBars();
							}, 300);
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			})
			.catch(function (error) {
				console.error(error);
			});
		},
		animateBars: function () {
			this.$logger("app/component/poll/animateBars");

			var component = this;

			var poll = document.getElementById(
				"poll-result-options-" + component.id
			);
			
			var bars = poll.getElementsByClassName("uk-progress");
			var animate = [];
			var barsCompleted = 0;
			var barsIntervals = [];

			for (var i = 0; i < bars.length; i++) {
				var bar = bars[i];
				var currentValue = parseInt(bar.value);
				var targetValue = parseInt(bar.getAttribute("target"));
				bar.value = targetValue;
			}
		},
		resetMessage: function() {
			var component = this;

			component.message = null;
			component.error = false;
			component.overlay = false;
			component.loading = false;		
		}		
	},
};
</script>
